import { render, staticRenderFns } from "./CompraMaterialesNew.vue?vue&type=template&id=d120f64e&scoped=true&"
import script from "./CompraMaterialesNew.vue?vue&type=script&lang=ts&"
export * from "./CompraMaterialesNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d120f64e",
  null
  
)

export default component.exports